
import React, {useRef, useState} from "react";
import { toast } from "react-toastify";
import "./HandleShare.css"
import Alert from "./Alert";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "./UtilsFunction";

const handleShare = async (productTitle, productDesc, productImage , fromWhere= undefined, pageUrl= null, clickedSharedButton = null, shareForm= null) => {
    // console.log("Attempting to share content:", productTitle, productDesc, productImage);


  
    if (navigator.canShare && navigator.canShare({ files: [new File([""], "test.jpg", { type: "image/jpeg" })] })) {

   const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

   if(isMobile && fromWhere === "BoldTextTools"){
    console.log("yes clicked in ttb")

   }

  try {
    console.log("share product image", productImage)
    // First fetch the image and prepare file
    const response = await fetch(productImage);
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: "image/jpeg" });

    // 1️⃣ For Caption Tools — Only text + URL (no image)
    if (fromWhere === "captionTools") {
      await navigator.share({
        title: productTitle,
        text: productDesc,
        url: pageUrl || window.location.href,
      });
      return;
    }

    // 2️⃣ Mobile Sharing — Image + URL + Caption copied
    if (isMobile && navigator.share) {

      // Copy caption automatically
      let caption = `Take a look for ${productTitle} images on BrowseNext...`      
      // await navigator.clipboard.writeText(caption);
      // toast.success("Caption & Link copied to clipboard!", {
      //   position: "top-center",
      //    hideProgressBar: true,
      //   autoClose: 1500,
      //     draggable: true,
      // });
      setTimeout(async ()=>{
        await navigator.share({
          title: productTitle,
          url: pageUrl || window.location.href,
          // url: caption,
          files: [file],
          text: caption
        });

      }, 50)

      
      return;
    }

    // 3️⃣ Desktop — Show custom share modal
    const sharedBox = document.querySelector(".contain_desktop_sharer");

    sharedBox.classList.toggle("show");
    if(shareForm === "normalShare"){
       sharedBox.firstElementChild.classList.add("normal_share");
    }else{
    sharedBox.firstElementChild.classList.remove("normal_share");
    }

    if (sharedBox.classList.contains("show")) {
      sharedBox.firstElementChild.classList.add("full-width");
    } else {
      sharedBox.firstElementChild.classList.remove("full-width");
    }
  } catch (err) {
    console.error("Share failed:", err);
  }



} else {
      alert('Web Share API is not supported in your browser or the current device cannot share files.');
    }
  };

  function ShareButton ({productTitle, productDesc, productImage, btnClass, callingFrom, BoldTextTools}) {
  
    return (
      (callingFrom === "captionTools")
        ? <i className={`fa-solid fa-share-nodes icon_margin ${btnClass}`} 
         role="button" tabIndex={0} aria-label={`Share tools`}
         onClick={() => handleShare(productTitle, productDesc, productImage, callingFrom)}
          onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleShare(productTitle, productDesc, "", callingFrom)
                  }
                }}
        ></i> :
 <button className={`btn btn-sm btn-primary p_s_btn brand_button btnClass ${btnClass} margin_left_for_share`}  onClick={() => handleShare(productTitle, productDesc, productImage, callingFrom)}>
        Share 
        <i className="fa-solid fa-share-nodes icon_margin"></i>
        {/* <i class="fa-regular fa-share-from-square icon_margin"></i> */}
      </button>


      
     


      
    );
  }

  


  function ShareOnDesktop(props){

    const desktopSharerRef = useRef(null)
    console.log("props for shareOnDesktop", props)
    // for Share on the Whatsapp
       function shareOnWhatsApp(imageUrl, title, pageUrl) {
        const url = pageUrl;
        console.log("share on whatsapp", title)
        title =`Take a look for ${props.imageName} on BrowseNext
Click link to discover more similar ${props.shareType} 
\n
${pageUrl} `

        // const message = `${title}\n${url}\n${imageUrl}`;    // for the image
        // const message = `${title}\n${pageUrl}`;
        const message = title;
        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
      }

    // for Share on the Pintrest
      function shareOnPinterest(imageUrl, title, pageUrl) {
        // console.log("share on pintrest", imageUrl, title, pageUrl)
        const pinterestUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(pageUrl)}&media=${encodeURIComponent(imageUrl)}&description=${encodeURIComponent(title)}`;
        window.open(pinterestUrl, "_blank");

      }
    // for Share on the twitter
      function shareOnTwitter(caption, url) {
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(caption)}&url=${encodeURIComponent(url)}`, "_blank");
    }
    // for Share on the Facebook
    function shareOnFacebook(url) {
  // window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "_blank");
  
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
  window.open(fbUrl, "_blank");

}
    // for Share on the LinkedIn
function shareOnLinkedIn(url = window.location.href, caption) {
  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&summary=${encodeURIComponent(caption)}`, "_blank");
}
// for Share on the SMS
function shareSMS(caption, url = window.location.href) {
  window.open(`sms:?&body=${encodeURIComponent(caption + " " + url)}`);
}

  // for Copy Url
function copyCaption(Url) {
  navigator.clipboard.writeText(Url);
  toast.success("Link copy to clipboard")
   desktopSharerRef.current.classList.remove("show");
      desktopSharerRef.current.firstElementChild.classList.remove("full-width");
  
}

function closeDesktopSharerModel(e){
    if (e.target.classList.contains("contain_desktop_sharer")) {
      e.target.classList.remove("show");
      e.target.firstElementChild.classList.remove("full-width");
    }
}


function sendClickFeed(event , element){    
    let shareButton = event.target;
    console.log("this", element)
    // console.log("document.title in home", featuredStoredImage)
    if(shareButton){
      // buttonRef.current.style.backgroundColor = "#000000b8";
      // shareButton.firstElementChild.style.color = "white";
      shareButton.style.transition = "all 0.05s linear";
      shareButton.style.transform = "scale(0.9)";
      
      // shareButton.firstElementChild.style.backgroundColor = "white";
    }
    
  }
  function removeClickFeed(event){    
    let shareButton = event?.target;

    if(shareButton){
      // buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";
      // shareImage(imageUrl)
          // showBlog();
          // shareButton.style.backgroundColor = "";
      
    }
    
  }
  function orignalElement(event){
    let shareButton = event?.target;
    if(shareButton){
      // buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";         
    }    
  }


    return (
    <>
    <div className="container-fluid  contain_desktop_sharer" ref={desktopSharerRef} onClick={(e)=> closeDesktopSharerModel(e)}>
       <div  className={"desktop_sharer"}> 

       <div className="share_button_containers" onClick={() => shareOnWhatsApp( props.imageUrl, props.title, window.location.href)}
           onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
       >
         <i class="fa-brands fa-whatsapp whatsapp_icon" ></i>
         <span>Whatsapp</span>
       </div>

       <div className="share_button_containers" onClick={() => shareOnFacebook(props.title, window.location.href)}
           onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
       >
        <i class="fa-brands fa-facebook facebook_icon" ></i>
        <span>Facebook</span>
        </div>

        <div className="share_button_containers" onClick={() => shareOnTwitter(props.title, window.location.href)}
            onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
        >
        <i class="fa-brands fa-twitter twitter_icon" ></i>
        <span>Twitter(X)</span>
        </div>        
        {/* <i class="fa-brands fa-instagram instgram_icon"></i> */}
<div className="share_button_containers" onClick={() => shareOnPinterest(props.imageUrl, props.title, window.location.href)}
    onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
>
        <i class="fa-brands fa-pinterest pinterest_icon"></i>
        <span>Pinterest</span>
        </div>
        
        <div className="share_button_containers" onClick={() => shareOnLinkedIn(window.location.href, props.title)}
            onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
        >
        <i class="fa-brands fa-linkedin linkedin_icon"></i>
        <span>LinkedIn</span>
        </div>
        {/* <i class="fa-solid fa-comment-sms sms_icon"
        onClick={() => shareSMS(props.title, window.location.href)}
        ></i> */}
        <div className="share_button_containers"
        onClick={() => copyCaption(window.location.href)}
            onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
        >
        <i class="fa-regular fa-copy copy_icon" ></i> 
        <span>Copy Link</span>

      </div>
    </div>
   </div> 

   

    </>
    )
  }


//     function SearchOnDesktop(props){

//     const searchModelRef = useRef(null)
  

//     function closeSearchMode(e){
//   if (e.target.classList.contains("contain_desktop_sharer")) {
//     e.target.classList.remove("show");
//     e.target.firstElementChild.classList.remove("full-width");
//   }
// }
//     return (
//     <>
//     <div className="container-fluid  contain_desktop_sharer" ref={searchModelRef} onClick={(e)=> closeSearchMode(e)}>
//        <div  className={"desktop_sharer"}> 

     
//     </div>
//    </div> 

   

//     </>
//     )
//   }



const popularSet = [
  "sunset",
  "ocean",
  "mountains",
  "forest",
  "moon",
  "beach",
  "city lights",
  
  "waterfall",
  
  "space",
  
  "flowers",
  "rain",
   "travel",
  "winter",
  "aesthetic",
 
]

function SearchOnDesktop(props){

  
  const navigate = useNavigate()

  const [searchText, setSearchText] = useState("");

  function handleClickSearch(e, searchText){

     trackEvent("explore_next_search", {
    searchQuery: searchText,
    searchSource: "popular_chip"
  });

    closeSearchModal()
    navigate(`/explore-next/photo/${searchText}`);
  }

  function handleSearch(e){

    if(!searchText.trim()) return;

  trackEvent("explore_next_search", {
    searchQuery: searchText,
    searchSource: "input"
  });

    console.log("search query", searchText);

    // later:
    closeSearchModal()
    navigate(`/explore-next/photo/${searchText}`);
  }

  function closeSearchModal() {

  props.searchModalRef.current.classList.remove("show");
  props.searchModalRef.current.firstElementChild.classList.remove("full-width");

}

  function closeDesktopSharerModel(e){
  if (e.target.classList.contains("contain_desktop_search")) {
    e.target.classList.remove("show");
    e.target.firstElementChild.classList.remove("full-width");
  }
}

function sendClickFeed(event){
  let button = event.target;

  if(button){
    button.style.transition = "all 0.05s linear";
    button.style.transform = "scale(0.9)";
  }
}

function removeClickFeed(event){
  let button = event?.target;

  if(button){
    button.style.transform = "scale(1)";
  }
}

function orignalElement(event){
  let button = event?.target;

  if(button){
    button.style.transform = "scale(1)";
  }
}

  return (
    <>
      <div
        className="container-fluid contain_desktop_search"
        ref={props.searchModalRef}
        onClick={(e)=>closeDesktopSharerModel(e)}
      >
        <div className="desktop_search_content_container browsenext_search_container">

<div className="search_input_button_container">
          <input
            ref={props.searchInputRef}
            type="text"
            placeholder="Search inspiration..."
            value={searchText}
            onChange={(e)=>setSearchText(e.target.value)}
            className="search_input"
            name="app_searchbar"
             
             onKeyDown={(e)=>{
    if(e.key === "Enter"){
      handleSearch();
    }
  }}
  
          />

          <button
            className="search_button"
            onClick={handleSearch}
            onMouseDown={sendClickFeed}
            onMouseUp={removeClickFeed}
            onMouseOut={orignalElement}
          >
            Search
          </button>

          </div>
          <div className="search_popular_set">
          <h3 className="popular_search_heading">Popular Search Inspirations</h3>
          
         <div className="search_popular_tags">
            {popularSet.map((topic)=>{
              const searchTag = topic.charAt(0).toUpperCase() + topic.slice(1)
            return(<>
            <button className="search_tags_for_images" onClick={(event)=>handleClickSearch(event, topic)}>{searchTag}</button>

            </>)
          })}
         </div>

         

          </div>




        </div>
      </div>
    </>
  );
}
  export{handleShare, ShareButton, ShareOnDesktop, SearchOnDesktop}